module.exports = __webpack_public_path__ + "static/media/arrow-complete-right.5f20433a.svg";